/**
 * Update this file once a year when a new aid year opens.
 * Keep newest first. CURRENT_AID_YEAR (dashboard “up to date”, etc.) is AID_YEARS[0].
 */
export const AID_YEARS = [
  { label: '2027-2028', code: 2728 },
  { label: '2026-2027', code: 2627 },
  { label: '2025-2026', code: 2526 },
];

/** Newest live aid year. */
export const CURRENT_AID_YEAR = 2627; //AID_YEARS[0].code;
export const CURRENT_AID_YEAR_LABEL = '2026-2027'; //AID_YEARS[0].label;

/** Live aid years plus one year prior. */
export const COHORT_YEARS = [
  '2027-2028',
  '2026-2027',
  '2025-2026',
  '2024-2025',
];

const MIN_SUPPORTED_AID_YEAR = 2526;

export function formatAidYear(aidYear: number): string {
  const code = aidYear.toString();
  return `20${code.slice(0, 2)}-20${code.slice(2)}`;
}

export function isAidYearSupported(aidYear: number): boolean {
  return !!aidYear && aidYear >= MIN_SUPPORTED_AID_YEAR;
}

export function unsupportedAidYearMessage(aidYear: number): string {
  return `Aid year ${formatAidYear(aidYear)} is no longer supported. Please contact support.`;
}
